import type { PropsWithChildren, ReactNode } from 'react';

type LayoutProps = PropsWithChildren;

/**
 * Generic layout to center the content and set max-width should be used to wrap all tipsen games.
 *
 * @param root0 the input props
 * @param root0.children the children to pass down
 * @returns div that should wrap the page.
 */
export default function Layout({ children }: LayoutProps): ReactNode {
  return <div className="mx-auto w-full max-w-[1440px]">{children}</div>;
}
